var __jsx = React.createElement;
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import { useIsFocused, useOnUserSelected, Pocket } from '@pelotoncycle/waffles';
import React from 'react';
import { isDefined } from '@peloton/types';
import { If } from '@engage/conditional-render';
import { MediumButton } from '@webtv/buttons';
import { focusClass } from '@webtv/global-styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ErrorType;

(function (ErrorType) {
  ErrorType["Login"] = "login";
  ErrorType["Loading"] = "loading";
  ErrorType["CreateAccount"] = "create-account";
  ErrorType["EmailExists"] = "email-exists";
  ErrorType["AccountLocked"] = "account-locked";
})(ErrorType || (ErrorType = {}));

export var ErrorModal = function ErrorModal(_ref) {
  var titleCopy = _ref.titleCopy,
      mainCtaCopy = _ref.mainCtaCopy,
      mainCta = _ref.mainCta,
      descriptionCopy = _ref.descriptionCopy,
      secondaryCtaCopy = _ref.secondaryCtaCopy,
      secondaryCta = _ref.secondaryCta,
      className = _ref.className;
  var mainFocusRef = React.useRef();
  var ariaLabel = "\n   ".concat(titleCopy, ".\n   ").concat(descriptionCopy, ".\n   ").concat(mainCtaCopy, "\n  ");
  return /*#__PURE__*/_jsx(Pocket, {
    id: "container",
    vertical: true,
    children: /*#__PURE__*/_jsxs(Container, {
      role: "dialog",
      className: cx(className),
      children: [/*#__PURE__*/_jsx(Header, {
        "data-test-id": "errorHeader",
        children: titleCopy
      }), /*#__PURE__*/_jsx(If, {
        condition: isDefined(descriptionCopy),
        children: /*#__PURE__*/_jsx(Description, {
          children: descriptionCopy
        })
      }), /*#__PURE__*/_jsx(Pocket, {
        id: "main-cta",
        position: 0,
        autofocus: true,
        focusRef: mainFocusRef,
        children: /*#__PURE__*/_jsx(MainCtaButton, {
          handleClick: mainCta,
          ariaLabel: ariaLabel,
          focusRef: mainFocusRef,
          children: mainCtaCopy
        })
      }), /*#__PURE__*/_jsx(If, {
        condition: isDefined(secondaryCtaCopy) && isDefined(secondaryCta),
        children: /*#__PURE__*/_jsx(Pocket, {
          id: "secondary-cta",
          position: 1,
          children: /*#__PURE__*/_jsx(SecondaryCta, {
            secondaryCta: secondaryCta,
            secondaryCtaCopy: secondaryCtaCopy
          })
        })
      })]
    })
  });
};

var SecondaryCta = function SecondaryCta(_ref2) {
  var secondaryCta = _ref2.secondaryCta,
      secondaryCtaCopy = _ref2.secondaryCtaCopy;
  var ref = React.useRef(null);
  var isFocused = useIsFocused();
  useOnUserSelected(function () {
    secondaryCta();
  });
  React.useEffect(function () {
    if (isDefined(ref.current)) {
      if (isFocused) {
        ref.current.focus();
      }
    }
  }, [isFocused]);
  return /*#__PURE__*/_jsx(SecondaryCtaLink, {
    className: cx(isFocused && focusClass),
    role: "button",
    children: secondaryCtaCopy
  });
};

var Container = /*#__PURE__*/styled("div")({
  name: "Container",
  class: "ckwadu6"
});
var Header = /*#__PURE__*/styled("h1")({
  name: "Header",
  class: "h1p02smj"
});
var Description = /*#__PURE__*/styled("p")({
  name: "Description",
  class: "d1pazdz8"
});
var MainCtaButton = /*#__PURE__*/styled(MediumButton)({
  name: "MainCtaButton",
  class: "miwc0p0"
});
var SecondaryCtaLink = /*#__PURE__*/styled("div")({
  name: "SecondaryCtaLink",
  class: "s1bdo6cq"
});

require("../../../apps/tv/.linaria-cache/packages/@webtv/error-modal/ErrorModal.linaria.module.css");